import { createReducer } from "@reduxjs/toolkit";

import {
  miniGamesInitRequest,
  miniGamesInitSuccess,
  miniGamesInitFailure,
  MiniGamesData,
} from "./miniGamesActions";

export type MiniGamesState = {
  games?: MiniGamesData;
  loaded: boolean;
  loading: boolean;
  error?: string;
};

const initialState: MiniGamesState = { loading: false, loaded: false };

export const miniGamesReducer = createReducer(initialState, (b) => {
  b.addCase(miniGamesInitRequest, (s) => {
    s.loading = true;
    s.error = undefined;
  });

  b.addCase(miniGamesInitSuccess, (s, a) => {
    s.loading = false;
    s.loaded = true;
    s.games = a.payload.games;
  });

  b.addCase(miniGamesInitFailure, (s, a) => {
    s.loading = false;
    s.error = a.payload;
  });
});

// Selectors
export const selectMiniGames = (state: any) => state.miniGames.games;
export const selectMiniGamesLoading = (state: any) => state.miniGames.loading;
export const selectMiniGamesError = (state: any) => state.miniGames.error;
export const selectMiniGamesRewards = (state: any) => state.miniGames.rewards;
export const selectGoldAmount = (state: any) =>
  state.miniGames.rewards?.goldAmount ?? 0;
export const selectSilverAmount = (state: any) =>
  state.miniGames.rewards?.silverAmount ?? 0;
export const selectBronzeAmount = (state: any) =>
  state.miniGames.rewards?.bronzeAmount ?? 0;
